import { render, staticRenderFns } from "./StatsCurrentRate.vue?vue&type=template&id=bbf78bf6&scoped=true"
import script from "./StatsCurrentRate.vue?vue&type=script&lang=js"
export * from "./StatsCurrentRate.vue?vue&type=script&lang=js"
import style0 from "./StatsCurrentRate.vue?vue&type=style&index=0&id=bbf78bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf78bf6",
  null
  
)

export default component.exports